import { render, staticRenderFns } from "./CategorySubEdit.vue?vue&type=template&id=3a7d5cb6"
import script from "./CategorySubEdit.vue?vue&type=script&lang=js"
export * from "./CategorySubEdit.vue?vue&type=script&lang=js"
import style0 from "./CategorySubEdit.vue?vue&type=style&index=0&id=3a7d5cb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports